import React from 'react'
import './style/outtro.scss'

const Outro = () => {
  return (
    <div className="outtro text-center text-white no-gutters pt-5">
        <h1 className="pt-5">Join the Movement</h1>
        <p className="py-3">Begin your planting journey with 10% off.</p>
        <hr/>
    </div>
)
}

export default Outro
